import { RefObject } from 'react';

import { GridApiPro } from '@mui/x-data-grid-pro';
import { useQuery } from '@tanstack/react-query';

import { useDreListContext } from '../contexts/DreListContext';
import { RequestDreListProps } from '../types';
import { useDreFilterLojas } from './useDreFilterLojas';
import { useDreListCalculate } from './useDreListCalculate';

import { useListagemContext } from 'context/ListagemContext';
import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryDreList({ grid }: { grid: RefObject<GridApiPro | null> }) {
    const { setHasDre } = useDreListContext();
    const requestListagem = useRequestListagem();
    const { filter, autoLoad } = useListagemContext();
    const filterLojas = useDreFilterLojas();
    const { calculateRows } = useDreListCalculate({ grid });
    const isMultipleLojas = filterLojas?.value.length > 1;

    const requestOptions = {
        url: isMultipleLojas ? '/dre/dremercadologica/consulta' : '/dre/dremercadologica',
        columns: 'idDreMercadologica',
        nested: true,
        filter,
    };

    return useQuery<RequestDreListProps>([requestOptions], () => requestListagem(requestOptions).then((res) => res.data), {
        enabled: autoLoad,
        cacheTime: 0,
        onSuccess: (data) => {
            setHasDre(Boolean(data.data.length));

            calculateRows(data.data);
        },
    });
}
